import * as actionTypes from "./actionTypes"
import { combineReducers } from "redux"


const initialStateDatasets = {
  datasets: undefined,
  fixedFilters: undefined,
  selectedDataset: undefined
}

const reducerDatasets = (
  state = initialStateDatasets,
  action
) => {
  switch (action.type) {
    case actionTypes.GET_MY_DATASETS:
      let result = {
        ...state,
        datasets: action.datasets,
        fixedFilters: action.fixedFilters
      }
      if (state.selectedDataset) {
        action.datasets.forEach(dataset => {
          if (dataset.dataset === state.selectedDataset.dataset) {
            result.selectedDataset = dataset;
          }
        })
      }
      return result;
    case actionTypes.SELECT_DATASET:

      if (action.dataset) {
        let lastDatasets = null;
        try {
          lastDatasets = JSON.parse(localStorage.getItem('lastDatasets'));
        } catch (error) {
          localStorage.setItem('lastDatasets', [])
        }
        lastDatasets = lastDatasets || [];
        lastDatasets = lastDatasets.filter(item => item.dataset !== action.dataset.dataset);
        lastDatasets.unshift({ dataset: action.dataset.dataset, name: action.dataset.name });
        lastDatasets = lastDatasets.slice(0, 5);
        localStorage.setItem('lastDatasets', JSON.stringify(lastDatasets));
      }

      return {
        ...state,
        selectedDataset: action.dataset
      }
    default:
  }
  return state;
}

const initialStateInterface = {
  leftPanel: undefined
}

const reducerInterface = (
  state = initialStateInterface,
  action
) => {
  switch (action.type) {
    case actionTypes.OPEN_LEFT_PANEL:
      return {
        ...state,
        leftPanel: action.leftPanel
      }
    case actionTypes.SELECT_DATASET:
      return {
        ...state,
        selectedDataset: action.dataset
      }
    default:
  }
  return state;
}

const initialStateUser = {
  userInfo: undefined,
  metricId: undefined
}

const reducerUser = (
  state = initialStateUser,
  action
) => {
  switch (action.type) {
    case actionTypes.SET_METRIC:
      return {
        ...state,
        metricId: action.metricId
      }
    case actionTypes.SET_USER:
      return {
        ...state,
        userInfo: action.userInfo
      }
    default:
  }
  return state;
}

const initialStateUpdTableModal = {
  isOpen: false,
  tableName: null
}

const reducerUpdTableModal = (
  state = initialStateUpdTableModal,
  action
) => {
  switch (action.type) {
    case actionTypes.SET_UPD_TABLE_MODAL:
      return {
        ...state,
        isOpen: action.isOpen,
        tableName: action.tableName
      }
    default:
  }
  return state;
}

const rootReducer = combineReducers({
  datasetsReducer: reducerDatasets,
  interfaceReducer: reducerInterface,
  userReducer: reducerUser,
  reducerUpdTableModal: reducerUpdTableModal
})

export default rootReducer;